import { Origami } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { cn } from '@/utils';

export { Card } from '@/components/ui/card';

export const PrimaryCard = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  return <Card className={cn('gap-0 rounded-md border-none p-4', className)} {...rest} />;
};

export const SecondaryCard = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  return (
    <Card
      className={cn('gap-0 rounded-md border-1 border-gray-300 p-8 shadow-sm', className)}
      {...rest}
    />
  );
};

export const ButtonCard = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  return <Card className={cn('min-h-12 space-y-4 rounded-md px-4 py-2', className)} {...rest} />;
};

export const NoCard = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  return <Card className={cn('space-y-4 rounded-md border-none p-8', className)} {...rest} />;
};

export const ClickablePrimaryCard = ({
  className,
  image,
  ...rest
}: React.ComponentProps<'div'> & { image?: string }) => {
  return (
    <Card
      className={cn(
        'space-y-4 rounded-md border-none p-6 hover:scale-[1.025] hover:shadow-lg',
        className,
      )}
      style={{
        backgroundImage: `url(${image})`,
        width: '100%',
        height: '100%',
        backgroundPosition: 'center',
      }}
      {...rest}
    />
  );
};

export const ClickableSecondaryCard = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  return (
    <Card
      className={cn('rounded-md p-4 hover:scale-[1.02] hover:shadow-lg', className)}
      {...rest}
    />
  );
};
